// @ts-ignore
const { translations } = PULSE.I18N;

/**
 * @param {string} label - A translation label key.
 * @returns {string} The translation.
 */
export const getTranslation = (label) => translations[label];

/**
 * @typedef {(suffix: string) => string} CurriedGetTranslation
 */

/**
 * @param {string} prefix - The beginning of a translation label key.
 * @returns {CurriedGetTranslation} A function which will get the translation
 *    based on the provided prefix and suffix.
 */
export const composeGetTranslation = (prefix) => {
    return (suffix) => {
        return translations[prefix + suffix];
    };
};
